import { xdr } from 'tokend-js-sdk'
import { ResponseBuilder } from '../response_builder'

export class TransactionResponseBuilder extends ResponseBuilder {
  constructor (response) {
    super(response)
    this._parsedData = response
  }

  result () {
    const resultXDR = this._parsedData.result_xdr
    /*eslint-disable*/
    return xdr.TransactionResult.fromXDR(new Buffer(resultXDR, 'base64'))
    /*eslint-enable*/
  }

  requestID () {
    return this.result().result().results()[0].tr().manageAssetResult().success().requestId().toString()
  }
  contractRequestID () {
    return this.result().result().results()[0].tr().manageContractRequestResult().success().details().response().requestId().toString()
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/response_builder/modules/transaction_response_builder.js